module.exports = __webpack_public_path__ + "media/images/1200/insomnia_moon_dark_skies-53faa7ed5b616b40aeea7ad369e18a72.jpg";